import React, { FC, Fragment } from 'react';
import { Select } from '@ui';

import { useFieldArray, useFormContext } from 'react-hook-form';

import { OptionItem } from '@app/components/ui/select/select.type';

import Icon from '@app/components/ui/icons';

import useTranslation from '@app/hooks/use-translation';

import AppealFilterNestedField from './appeal-filter-nested-field';
import { FilterOptionsListAndRules } from './types';
import { conditionsMapByFieldType } from './data';

type FilterFieldType = {
  keysForFiltering: FilterOptionsListAndRules[];
  modalMode?: boolean;
  additionalObjectName?: string;
  fieldName?: string;
};
const AppealFilterField: FC<FilterFieldType> = (props) => {
  const { keysForFiltering, additionalObjectName, fieldName } = props;
  const { t } = useTranslation('components.filter');
  const { control, setValue, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: additionalObjectName || 'filter',
  });
  function getParamsSelectOptions(): OptionItem[] {
    return keysForFiltering
      .filter((val) => !val.hide)
      .map((item) => ({ title: item.title, value: item.index }));
  }

  const getConditionsTypeByValue = (value: string) => {
    const condition = getFieldByValue(value)?.conditions || 'all';
    return conditionsMapByFieldType[condition];
  };
  const getFieldByValue = (value: string) => {
    return keysForFiltering.find((key) => key.index === value);
  };

  function onChangeParams(value, index, options) {
    setValue(`${additionalObjectName || 'filter'}[${index}].${fieldName || 'field'}`, value);
    setValue(`${additionalObjectName || 'filter'}[${index}].condition`, options?.[0]?.value);
  }

  return (
    <ul className={'flex flex-col px-[32px]'}>
      {fields.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 && (
            <div
              className={
                'h-[17px] w-full flex items-center justify-center text-[14px] leading-[17px] font-[400] text-4color'
              }
            >
              {t('and')}
            </div>
          )}
          <li className="flex items-center py-4 relative bg-defaultBg rounded-[12px] border-solid border-l-[2px] border-speech_analitics px-[24px]">
            <div className={'flex items-start justify-center gap-[16px]'}>
              <div className={'w-[360px]'}>
                <Select
                  dropWidth={356}
                  defaultValue={watch(
                    `${additionalObjectName || 'filter'}[${index}].${fieldName || 'field'}`,
                  )}
                  withSearch
                  onChange={(value) =>
                    onChangeParams(value, index, getConditionsTypeByValue(value as string))
                  }
                  options={getParamsSelectOptions()}
                  dropTop={index >= 2}
                />
              </div>
              <div className={'w-[120px]'}>
                <Select
                  defaultValue={watch(`${additionalObjectName || 'filter'}[${index}].condition`)}
                  onChange={(value) => {
                    setValue(`${additionalObjectName || 'filter'}[${index}].condition`, value);
                    // if (
                    //   conditionsWithoutValue.includes(value.toString()) &&
                    //   fields.length < index + 2
                    // ) {
                    //   append('');
                    // }
                  }}
                  dropTop={index >= 2}
                  options={getConditionsTypeByValue(
                    watch(`${additionalObjectName || 'filter'}[${index}].${fieldName || 'field'}`),
                  )}
                />
              </div>
              <AppealFilterNestedField
                fieldsLength={fields.length}
                fieldObject={getFieldByValue(
                  watch(`${additionalObjectName || 'filter'}[${index}].${fieldName || 'field'}`),
                )}
                appendFilter={append}
                nestIndex={index}
                keysForFiltering={keysForFiltering}
                additionalObjectName={additionalObjectName}
              />
            </div>
            {(additionalObjectName ? true : fields.length !== index + 1) && (
              <div className={'cursor-pointer absolute right-[-25px]'}>
                <Icon
                  name="TrashIcon"
                  className="!text-basic_red"
                  size={14}
                  onClick={() => remove(index)}
                />
              </div>
            )}
          </li>
        </Fragment>
      ))}
    </ul>
  );
};

export default AppealFilterField;
